import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { BaseService } from "src/modules/base/shared/services/base.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CommunicationService } from "src/modules/base/services/communication.service";
import { AppService } from "src/modules/base/shared/services/app.service";
import { AlertsService } from "src/modules/base/services/alerts.service";
import { LoaderService } from "src/modules/base/services/loader.service";
import { StorageService } from "src/modules/base/shared/services/storage.service";
import { PopupFormComponent } from "src/modules/base/components/popupform/popupform.component";
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { Subscription } from "rxjs";
@Component({
    selector: "app-indent-issue",
    templateUrl: "./indent-issue.component.html",
    styleUrls: ["./indent-issue.component.scss"],
    standalone: false
})
export class IndentIssueComponent implements OnInit {
  public _currentData: any = {};
  isPinRequired: boolean = false;
  subscription: Subscription;
  //public _layout_data: any = {};
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    public baseService: BaseService,
    public dialogService: DialogService,
    public communicationService: CommunicationService,
    public appService: AppService,
    private alerts: AlertsService,
    private loader: LoaderService,
    private storage: StorageService
  ) { }
  ngOnInit() {
    this._currentData.config = {
      submitButton: true,
      cancelButton: true,
      filterForm: false,
      clearOnSave: false,
      delegateSave: true,
      cancelRoute: "",
    };// <! ********************************check pin Code Config******************************************>
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:pin_required", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0)
        data.resource[0].multivalue.find(e => {
          if (e.id == "po_approval") {
            this.isPinRequired = true;
          }
        })
    })// <! ********************************check pin Code Config******************************************>
    let currentOrganization = this.appService.getOrganization();
    this._currentData.resource = this.route.snapshot.params.resource;
    let queryParams = this.route.snapshot.queryParams;
    if (queryParams != undefined) {
      this._currentData.redirectUrl = queryParams.returnUrl;
      let jsondata: any = {};
      if (queryParams && queryParams.hasOwnProperty("data") && queryParams.data) {
        jsondata = JSON.parse(queryParams.data);
      }
      if (jsondata.application)
        this._currentData.application = jsondata.application;
      else this._currentData.application = this.appService.getApplication();
      this._currentData.dataresource = jsondata.resource;
      this._currentData.getresource = jsondata.getresource;
      if (jsondata.getQueryId)
        this._currentData.getQueryId = jsondata.getQueryId;
      this._currentData.actionresource = jsondata.actionresource;
      if (jsondata.action_name)
        this._currentData.actionname = jsondata.action_name;
      if (this._currentData.getresource == this._currentData.actionresource) {
        // update
        this._currentData.currentAction = "MODIFY";
        this._currentData.customButton = {
          Add: [
            {
              label: "button.submit",
              type: "btn",
            },
          ],
        };
      } else {
        // Add
        this._currentData.currentAction = "ADD";
        this._currentData.customButton = {
          Add: [
            {
              label: "button.submit",
              type: "btn",
            },
          ],
        };
      }
    }

    this._currentData.currentId = this.route.snapshot.params.id;
    this._currentData.json = this._currentData.resource;
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        this.baseService.setTitleFromResouceDef(
          resouceDef,
          this._currentData.currentAction
        );
        this.getDataForCurdOperation(resouceDef);
      }
    });
    if (this._currentData.json == "purchase_order_approval_detail" || this._currentData.json == "purchase_order_approval_detail_remodify") {
      this.getSupplierDetails();
    }
    if (this._currentData.json == "interfacility_sale_reject_return" || this._currentData.json == "interfacility_sale_return_acknowledge_detail" || this._currentData.json == "return_indent_acknowledge" || this._currentData.json == "interfacility_reject_return" || this._currentData.json == "interfacility_return_acknowledge_detail" || this._currentData.json == "interfacility_direct_issue_receipt_detail" || this._currentData.json == "interfacility_indent_issue_add" || this._currentData.json=="interfacility_sale_indent_issue_add") {
      this.appService.setLocationAwareConfig(false);
    }
  }
  getSupplierDetails() {
    let sup = sessionStorage.currentData ? JSON.parse(sessionStorage.currentData) : {};
    if (sup && sup.supplierId) {
      let apiObj = {
        args: "id:" + sup.supplierId,
      };
      this.baseService
        .get("GET_BY_ID", apiObj.args, "supplier", "inventory-management")
        .subscribe(
          (res) => {
            if (res && res.errCode == 0 && res.resource && res.resource.length > 0) {
              let response = res.resource[0];
              let sup_details = response.contact_person_details;
              if (!sup_details.email_address) {
                this.alerts.info("Email Address for supplier not configured");
                return false;
              }
            }
          },
          (err) => { }
        );
    }
  }
  getDataForCurdOperation(resouceDef: any) {
    this._currentData.resouceDef = resouceDef;
    // localStorage.setItem("CurrentResource", resouceDef.resource);
    this.storage.setCurrentResource(resouceDef.resource);
    this._currentData.resource = resouceDef.resource;
    if (resouceDef.form != undefined && resouceDef.form) {
      this.baseService.getReferredField(resouceDef.form, (response) => {
        this._currentData.currentFormFields = {};
        this._currentData.currentFormFields.blocks = response;
        if (
          this._currentData.resouceDef &&
          this._currentData.resouceDef.hasOwnProperty("custom_button")
        ) {
          this._currentData.customButton =
            this._currentData.resouceDef.custom_button;
        }
      });
    }
    this.getByQueryID();
  }

  listResource() {
    this.router.navigateByUrl(this._currentData.redirectUrl);
  }

  getByQueryID() {
    var apiObj: any = {};
    if (this._currentData.getQueryId) {
      apiObj.query_id = this._currentData.getQueryId;
    } else {
      apiObj.query_id = "GET_BY_ID";
    }
    apiObj.application = this._currentData.application;
    apiObj.resource = this._currentData.getresource;
    apiObj.args = "id:" + this._currentData.currentId;
    this.baseService
      .get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application)
      .subscribe(
        (data: any) => {
          if (data.erroCode == -1) {
            this.alerts.error(data.message);
          } else {
            if (data.resource != undefined && data.resource.length > 0) {
              this._currentData.currentData = data.resource[0];
              //cloning id into indent_raised_id
              if (this._currentData.resource == "indent_issued_add") {
                this._currentData.currentData["indent_raised_id"] =
                  data.resource[0].id;
              }
              if (this._currentData.resource == "storeConsumption") {
                this._currentData.currentData["cancelled_remark"] = " ";
              }
            } else {
              this._currentData.currentData = [];
            }

          }
          this.loader.hideSpinner();
        },
        (error) => {
          console.log(error);
          this.alerts.error("API error");
          this.loader.hideSpinner();
        }
      );
  }
   ngOnDestroy(): void {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}
  onSaveFinished(event) {
    if (this.baseService.router && this.baseService.router.routerState.snapshot.url.includes("purchase_request_approval_detail_remodify")) {
      if(event?.result){
        if(event?.result){
          event.result['re_modification'] = true;
        }
      }
    }
    if (event.currentBtnVal && event.currentBtnVal.action === "approve_pr" && this.baseService.router && this.baseService.router.routerState.snapshot.url.includes("purchase_request_approval_detail")) {
      let purchaseRequestDetails = event?.result.purchase_request_detail;
      if (purchaseRequestDetails && purchaseRequestDetails.length > 0) { 
        for (let d of purchaseRequestDetails) {
          if (!d.itemStatus || d.itemStatus === "" || d.itemStatus === "Pending" || d.itemStatus === "Partially Approved") {
            d.itemStatus = "Approved";
          }
        }
      } else {
        this.alerts.error("No item found.");
        return false;
      }
    }
    if(this._currentData.resource === "broken_stock_approval_detail") {
      let brokenStock = event?.result.brokenStock;
      if (brokenStock && brokenStock.length > 0) { 
        for (let d of brokenStock) {
          if (!d.status || d.satus === "" || d.status === "PENDING") {
            d.status = "Acknowledged";
          }
        }
      } else {
        this.alerts.error("No item found.");
        return false;
      }
    }
    if (this._currentData.resource === "consignment_issue_receipt_detail") {
      if (event?.result?.inventory_direct_issue_detail){
        this.subscription = this.communicationService.consigmentDetails$.subscribe((data) => {
          debugger;
          if (Array.isArray(data) && data.length > 0) {
            event.result.inventory_direct_issue_detail = data;
          }
        });
        for (let d of event.result.inventory_direct_issue_detail) {
          if (!Number.isInteger(d.receivedQuantity)) {

            this.alerts.error(`Remove decimal from Received Qty for item ` + d.itemName);
            return;
          }
          // if(!d.receivedQuantity){
          //   this.alerts.error(`Please fill Received Qty for item ` + d.itemName);
          //   return;
          // }
        }
      }
    }
    if(this._currentData.resource === "consignment_issue_return"){
      if (event?.result?.consignment_issue_return_detail){
        this.subscription = this.communicationService.consigmentReturnDetails$.subscribe((data) => {
          debugger;
          if (Array.isArray(data) && data.length > 0) {
            event.result.consignment_issue_return_detail = data;
          }
        });
        for (let d of event.result.consignment_issue_return_detail) {
          if (!Number.isInteger(d.receivedQuantity)) {

            this.alerts.error(`Remove decimal from Received Qty for item ` + d.itemName);
            return;
          }
          // if(!d.receivedQuantity){
          //   this.alerts.error(`Please fill Received Qty for item ` + d.itemName);
          //   return;
          // }
        }
      }
    }
    if(this._currentData.resource === "broken_stock_approval_detail") {
      let brokenStock = event?.result?.brokenStock;
      if (brokenStock && brokenStock.length > 0) { 
        for (let d of brokenStock) {
          if (!d.status || d.satus === "" || d.status === "PENDING") {
            d.status = "Acknowledged";
          }
        }
      } else {
        this.alerts.error("No item found.");
        return false;
      }
    }
    if (this._currentData.amountApi != undefined) {
      clearTimeout(this._currentData.amountApi);
    }
    this._currentData.amountApi = setTimeout(() => {
      try {
        if (this._currentData.currentAction == "MODIFY") {
          event.result.id = this._currentData.currentId;
        } else if (this._currentData.currentAction == "ADD") {
          if (event.result && event.result.id) {
            delete event.result.id;
          }
        }
        let action = ""
        if (this._currentData.actionname) {
          action = this._currentData.actionname;
        }
        if (this._currentData.actionname === "approve_hod_indent"){
          if (event?.result?.raisedItems){
            for (let d of event.result.raisedItems) {
              if (d.stock_in_hand == '') {
                d.stock_in_hand = 0;
              }
              if (d.freeData == '') {
                d.freeData = false;
              }
            }
          }
        }
        if(this._currentData.actionname === "acknowledge_return"){
          if (event?.result?.returnItems){
            for (let d of event.result.returnItems) {
              if (!d.expiryDate) {
                d.expiryDate = null;
              }
            }
          }
        }
        if (event.hasOwnProperty("currentBtnVal") && event.currentBtnVal && event.currentBtnVal.action) {
          action = event.currentBtnVal.action;
        } let application = this._currentData.application;
        // <! ********************************check pin Code for Submit Button Start******************************************>
        if (this.isPinRequired && this._currentData.currentAction == "MODIFY" && (this._currentData.json.includes('purchase_order_approval_detail') || this._currentData.json.includes('purchase_order_approval_detail_remodify'))) {
          let popObj = {
            "data": [], "action": "ADD", "getdata": true, "layout_type": "simple", "application": "emr",
            "title": 'Validate PIN',
            "size": DialogModalSize.Sm,
            "resource": 'op_validate_pin',
            "customButton": {
              "Add": [
                {
                  "label": "button.confirm",
                  "icon": "fa fa-check"
                }]
            }
          }
          this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(response => {
            if (response && response.result && response.result.pin) {
              this.loader.showSpinner();
              let inputPin = response.result.pin
              this.baseService.action({ pin: inputPin }, "authenticate_pin", "account-management", "manage_user_pin").subscribe(res => {
                if (res.errCode == 0) {
                  if (res.resource[0].is_authorised) {
                    this.baseService.action(event.result, action == "" ? this._currentData.currentAction : action, application, this._currentData.actionresource).subscribe((data: any) => {
                      if (data.errCode == -1) {
                        this.loader.hideSpinner();
                        this.alerts.error(data.message);
                      } else {
                        action = "";
                        this.alerts.success("Successfully created");
                        this.router.navigateByUrl(this._currentData.redirectUrl);
                        this.loader.hideSpinner();
                      }
                    },);
                  } else {
                    this.loader.hideSpinner();
                    this.alerts.error("Incorrect PIN");

                  }}
              })}
          })       
        }// <! ********************************check pin Code for Submit Button end******************************************>
        else { 
          if (event.result) { 
            this.loader.showSpinner();
            this.baseService.action(event.result, action == "" ? this._currentData.currentAction : action, application, this._currentData.actionresource).subscribe((data: any) => {
              if (data.errCode == -1) {
                action = "";
                this.loader.hideSpinner();
                this.alerts.error(data.message);
              } else {
                action = "";
                this.alerts.success("Successfully created");
                this.router.navigateByUrl(this._currentData.redirectUrl);
                this.loader.hideSpinner();
              }
            },
              (error) => {
                console.log(error);
                this.alerts.error("API error");
                this.loader.hideSpinner();
              }
            );
          }
        }
      } catch (error) {
        this.loader.hideSpinner();
      }
    }, 1000)

  }
  ngAfterViewChecked() {
    // need to discuss this point in refactor
    // if (
    //   document.getElementsByClassName("submitButton") &&
    //   document.getElementsByClassName("submitButton")[0]
    // ) {
    //   document.getElementsByClassName("submitButton")[0]["innerText"] =
    //     "Submit";
    // }
    this.checkIndentIssueValidation();
  }
  checkIndentIssueValidation() {
    // Code need to remove once common validation is done in form component
    if (this._currentData.getresource == "indent_raised") {
      if (
        document.getElementById("batchNo") &&
        !document.getElementById("batchNo")["value"]
      ) {
        if (
          document.getElementsByClassName(
            "input-error-msg editgrid-error-msg"
          ) &&
          document.getElementsByClassName(
            "input-error-msg editgrid-error-msg"
          )[0]
        ) {
          document.getElementsByClassName(
            "input-error-msg editgrid-error-msg"
          )[0]["innerText"] = "Invalid batch no.";
          return false;
        }
      }
      if (
        this._currentData.currentData &&
        this._currentData.currentData.raisedItems &&
        this._currentData.currentData.raisedItems.length > 0
      ) {
        for (let d in this._currentData.currentData.raisedItems) {
          let id = `issuedquantity${d}`;
          if (
            document.getElementById(id) &&
            !document.getElementById(id)["value"]
          ) {
            if (
              document.getElementsByClassName(
                "input-error-msg editgrid-error-msg"
              ) &&
              document.getElementsByClassName(
                "input-error-msg editgrid-error-msg"
              )[0]
            ) {
              document.getElementsByClassName(
                "input-error-msg editgrid-error-msg"
              )[0]["innerText"] = "Invalid issuing quantity";
              break;
            }
          }
        }
      }
    }
  }
}
